const YOUTUBE_ID_RE = /^[A-Za-z0-9_-]{11}$/;

/**
 * watch URL / 短縮 URL / embed URL / 生の 11 桁 ID から動画 ID を取り出す。
 * 熱狂の宴は watch URL を保存し、AI トレードアリーナは生の ID を保存しているため両方受ける。
 */
export function youtubeVideoId(urlOrId: string | null | undefined): string | null {
  const raw = String(urlOrId || '').trim();
  if (!raw) return null;
  if (YOUTUBE_ID_RE.test(raw)) return raw;
  try {
    const parsed = new URL(raw);
    const host = parsed.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') {
      const id = parsed.pathname.split('/').filter(Boolean)[0] ?? '';
      return YOUTUBE_ID_RE.test(id) ? id : null;
    }
    if (host === 'youtube.com' || host === 'youtube-nocookie.com' || host.endsWith('.youtube.com')) {
      const fromQuery = parsed.searchParams.get('v') ?? '';
      if (YOUTUBE_ID_RE.test(fromQuery)) return fromQuery;
      const parts = parsed.pathname.split('/').filter(Boolean);
      // /embed/<id>・/shorts/<id>（ショート投稿の共有 URL）・/live/<id>
      for (const prefix of ['embed', 'shorts', 'live', 'v']) {
        const idx = parts.indexOf(prefix);
        if (idx >= 0 && YOUTUBE_ID_RE.test(parts[idx + 1] ?? '')) return parts[idx + 1]!;
      }
    }
  } catch {
    return null;
  }
  return null;
}

/** 再生用 iframe の src。CDN 禁止方針とは別で、動画配信は YouTube 埋め込みを正とする */
export function youtubeEmbedSrc(urlOrId: string | null | undefined): string | null {
  const id = youtubeVideoId(urlOrId);
  if (!id) return null;
  return `https://www.youtube-nocookie.com/embed/${id}`;
}

/** 「YouTube で見る」等の外部リンク先 */
export function youtubeWatchUrl(urlOrId: string | null | undefined): string | null {
  const id = youtubeVideoId(urlOrId);
  if (!id) return null;
  return `https://www.youtube.com/watch?v=${id}`;
}
